import React, { useState } from 'react';
import './blog-post.css';
import './blog-slides.css';

import pic1 from './pictures/pic1.JPG';
import pic2 from './pictures/pic2.JPG';
import pic3 from './pictures/pic3.JPG';
import pic4 from './pictures/pic4.JPG';

const BobaKahoot = () => {
  return (
    <div>
      <div className='blog__container'>
        <div class="row">
            <div class="column">
                <header>
                    <h3 class="site-post-title rounded title-padding">
                        <b>WiC at Work</b>
                    </h3>
                </header>
                <section>
                    <h2>First WiC Meeting of 2024-2025 School Year!</h2>
                    <p class="site-post-meta">October 10th, 2024</p>
                    <hr></hr>
                </section>
                <section>
                    <p>
                    Hi WiC members! 
                    <br></br>
                    <br></br>
                    Last Thursday, we had our first WiC meeting of the 2024-2025 year! After introducing the core values of WiC and our leadership board, members had the chance to break the ice and get to know one another. We played a fun Kahoot featuring UW Trivia and our top three winners won some extra special Allen School merch! 

And last but not least, members enjoyed some homemade boba made by our WiC officers! Everyone got to pick and choose their teas, milks, and toppings: definitely a well-deserved sweet treat to kick off the quarter!

It was so great to see both new and returning faces at the meeting! There is so much fun yet to come and we can’t wait for future events. 

                    </p>
                    <img src={pic1} alt="pic1 "/>
                    <img src={pic2} alt="pic2"/>
                    <img src={pic3} alt="pic3"/>
                    <img src={pic4} alt="pic4"/>
                </section>
            </div>
        </div>      
      </div>
    </div>
  );
};

export default BobaKahoot;
